import React from 'react';
import Tooltip from '~/components/Tooltip.jsx';

export default function ListTooltip(props) {
  return <Tooltip maxWidth="unset" {...props} />;
}
